'use strict';

import { EventEmitter } from 'events';
import assign from 'object-assign';
import TngAppDispatcher from '../dispatcher/TngAppDispatcher';
import processAction from 'services/storeUtils';

import appConstants from 'constants/appConstants';

var _isLoggedIn = false;
var _user;
var _signInError = false;
let _userIdp;
let _migrationUrl = null;
var _storeStatuses = {
    error: null,
    success: false,
    loading: false,
};

/**
 * Page is Loaded
 */
var pageLoaded = function (data) {
    _isLoggedIn = data?.user !== null;
    _user = data?.user;
    _signInError = data?.signInError;
};

const getUserIdp = (response) => {
    _storeStatuses = processAction(response, function (responseBody) {
        _userIdp = responseBody;
    });
};

const getMigrationUrl = (response) => {
    if (!_migrationUrl) {
        _migrationUrl = {};
    }
    var actions = processAction(response, function (responseBody) {
        _migrationUrl.migrationUrl = responseBody;
    });
    _migrationUrl.loading = actions.loading;
    _migrationUrl.error = actions.error; 
};


var AuthStore = assign({}, EventEmitter.prototype, {
    addChangeListener(callback) {
        this.on(appConstants.events.CHANGE, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(appConstants.events.CHANGE, callback);
    },
    addLoginChangeListener(callback) {
        this.on(appConstants.events.LOGIN, callback);
    },
    removeLoginChangeListener(callback) {
        this.removeListener(appConstants.events.LOGIN, callback);
    },
    addAccessTokenRevokedListener(callback) {
        this.on(appConstants.events.ACCESS_TOKEN_REVOKED, callback);
    },
    removeAccessTokenRevokedListener(callback) {
        this.removeListener(appConstants.events.ACCESS_TOKEN_REVOKED, callback);
    },
    getLoggedInUserData() {
        return {
            isLoggedIn: _isLoggedIn,
            user: _user,
            signInError: _signInError,    
        };
    },
    getIdpData() {
        const response = _storeStatuses;
        response.userIdp = _userIdp;
        return response;
    },
    getMigrationUrl() {
        return _migrationUrl;
    },
});

AuthStore.dispatchToken = TngAppDispatcher.register(function (payload) {
    var action = payload.action;
    switch (action.actionType) {

        case appConstants.actions.PAGE_LOADED:
            pageLoaded(action.data);
            AuthStore.emit(appConstants.events.CHANGE);
            break;

        case appConstants.actions.LOGIN:
            AuthStore.emit(appConstants.events.LOGIN);
            break;

        case appConstants.actions.AUTH.GET_USER_IDP:
            getUserIdp(action);
            AuthStore.emit(appConstants.events.CHANGE);
            break;
        
        case appConstants.actions.WORKSPACE_MIGRATION.GET_MIGRATION_URL:
            getMigrationUrl(action);
            AuthStore.emit(appConstants.events.CHANGE);
            break;

        case appConstants.actions.AUTH.ACCESS_TOKEN_REVOKED:
            AuthStore.emit(appConstants.events.ACCESS_TOKEN_REVOKED);
            break;

        default:
            return true;
    }

    return true;
});

export default AuthStore; 
